import ApiService from '@/services/api'

const state = {
  cores: [
    { label: 'Amarelo', value: 'Amarelo' },
    { label: 'Azul', value: 'Azul' },
    { label: 'Roxo', value: 'Roxo' },
    { label: 'Verde', value: 'Verde' },
    { label: 'Vermelho', value: 'Vermelho' },
    { label: 'Rosa', value: 'Rosa' }
  ],
  niveis: [
    { label: 'Iniciando', value: 'Iniciando' },
    { label: 'Aprendiz', value: 'Aprendiz' },
    { label: 'Praticante', value: 'Praticante' },
    { label: 'Profissional', value: 'Profissional' },
    { label: 'Professor', value: 'Professor' },
    { label: 'Mestre', value: 'Mestre' }
  ],

  todasHabilidades: []
}

const getters = {
  cores: state => state?.cores || [],
  niveis: state => state?.niveis || [],
  todasHabilidades: state => state?.todasHabilidades || []
}

const mutations = {
  ADICIONAR_HABILIDADE(state, habilidade) {
    // Verifica se a habilidade já existe para evitar duplicatas
    const existe = state.todasHabilidades.find(h => h.value === habilidade.value)
    if (!existe) {
      // Adiciona no início do array (topo) ao invés do final
      state.todasHabilidades.unshift({
        label: habilidade.label || '',
        value: habilidade.value || '',
        nivel: habilidade.nivel || 'Iniciando',
        grupo_nome: habilidade.grupo_nome || '',
        isNew: habilidade.isNew || false
      })
    }
  },
  
  REMOVER_FLAG_NEW(state, habilidadeValue) {
    const habilidade = state.todasHabilidades.find(h => h.value === habilidadeValue)
    if (habilidade) {
      habilidade.isNew = false
    }
  },
  
  REMOVER_HABILIDADE(state, habilidadeValue) {
    const index = state.todasHabilidades.findIndex(h => h.value === habilidadeValue)
    if (index !== -1) {
      state.todasHabilidades.splice(index, 1)
    }
  },
  
  ATUALIZAR_HABILIDADE(state, { value, novoNivel, novaLabel, grupoNome }) {
    const habilidade = state.todasHabilidades.find(h => h.value === value)
    if (habilidade) {
      if (novoNivel !== undefined) {
        habilidade.nivel = novoNivel
      }
      if (novaLabel !== undefined) {
        // Atualiza diretamente com o ID e label vindos das classes
        habilidade.value = novaLabel
        // A label será atualizada quando buscarmos o nome da skill nas classes
        // Isso será feito no componente
        
        // Adiciona o nome do grupo
        if (grupoNome) {
          habilidade.grupo_nome = grupoNome
        }
      }
    }
  },

  SET_TODAS_HABILIDADES(state, habilidades) {
    state.todasHabilidades = habilidades
  }
}

const actions = {
  adicionarHabilidade({ commit }, habilidade) {
    commit('ADICIONAR_HABILIDADE', habilidade)
  },
  
  removerHabilidade({ commit }, habilidadeValue) {
    commit('REMOVER_HABILIDADE', habilidadeValue)
  },
  
  atualizarHabilidade({ commit }, payload) {
    commit('ATUALIZAR_HABILIDADE', payload)
  },

  /**
   * Popula todasHabilidades a partir dos dados do usuário
   * @param {array} classes - Array de classes retornadas do endpoint
   */
  popularHabilidadesDoUsuario({ commit }, classes) {
    if (!classes || !Array.isArray(classes)) {
      return
    }

    const habilidades = []
    
    classes.forEach(classe => {
      if (classe.skills && Array.isArray(classe.skills)) {
        classe.skills.forEach(skill => {
          habilidades.push({
            label: skill.name,
            value: skill.skill_id, // ID da skill no banco, não o ID da relação
            nivel: skill.nivel || 'Iniciando',
            grupo_nome: classe.name || '',
            relationId: skill.id, // ID da relação usuário-skill para deletar
            isNew: false
          })
        })
      }
    })

    commit('SET_TODAS_HABILIDADES', habilidades)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
